import EpiContext from '@episerver/spa-core/Spa';
import {
  startTroubleshootingWizard, setClientRequestData, setProcessCheckpoint,
} from "app/Components/Block/AbroadTroubleshootingWizardBlock/TroubleshootingWizardSlice";
import AlertIcon from "app/Components/Block/AbroadTroubleshootingWizardBlock/Images/alert.svg";
import SuccessIcon from "app/Components/Block/AbroadTroubleshootingWizardBlock/Images/success.svg";
import BtnWhiteBlackBorderBigSize from "app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize";
import React from "react";
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import SelectList from "app/Components/Shared/SelectList/SelectList";
import {navigateToUrl} from "app/utilities/StringHelpers/StringHelpers";
import Config from "app/Config";
import {
  dwhAbroadWizardAllChecksFinished,
  dwhAbroadWizardButtonClicked
} from 'app/Components/Block/AbroadTroubleshootingWizardBlock/Reports/dwhReports';
import { TroubleshootingStepEnum } from '../../Enums/TroubleshootingStepEnum';
import { extractContentData } from '../../Utils/ContentDataUtils';

export const ProcessContent = (props) => {
  const { troubleshootingStep, process } = props.TroubleshootingWizardSlice;

  if (troubleshootingStep === TroubleshootingStepEnum.NO_ERROR ||
      troubleshootingStep === TroubleshootingStepEnum.RESOLVED_ROAMING_SWITCH_BLOCK
  ) {
    dwhAbroadWizardAllChecksFinished({ process });
  }
  const { submitListResult, setSelectedListResult } = props;
  const epiContent = extractContentData(props.contentData);

  const createLinkAction = (text, onClick) => (
    <a href="#" onClick={() => {
      dwhAbroadWizardButtonClicked({ param1: text, process });
      onClick();
    }}>
      {text}
    </a>
  );

  const processContentMap = {
    [TroubleshootingStepEnum.NO_ERROR]: {
      icon: AlertIcon,
      title: (
        <>
          סיימנו את כל הבדיקות
          <br />
          ולא מצאנו בעיות בקו
        </>
      ),
      subtitle: (
        <>
          כעת, כדי לבדוק שגם הגדרות המכשיר תקינות
          <br />
          מומלץ להמשיך למדריך
        </>
      ),
      action: createLinkAction(epiContent.operatorSelectionGuideLinkText, () => navigateToUrl(epiContent.operatorSelectionGuideLink)),
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },
    [TroubleshootingStepEnum.MUTUAL_CHECKS]: {
      showAppLoader: true,
      title: 'בודקים כמה דברים לפני שנמשיך',
    },
    [TroubleshootingStepEnum.UPDATING_SETTINGS]: {
      showAppLoader: true,
      title: 'מרעננים הגדרות',
    },
    [TroubleshootingStepEnum.RESTART_DEVICE]: {
      icon: AlertIcon,
      title: (
        <>
          להשלמת ההגדרות יש להדליק
          <br />
          ולכבות מצב טיסה במכשיר
        </>
      ),
      action: null,
      finishButton: <BtnSubmit text='המשך' onclick={() => submitListResult()} />,
    },
    [TroubleshootingStepEnum.REFRESH_SETTINGS_CONFIRMATION]: {
      icon: null,
      title: 'האם הבעיה נפתרה?',
      subtitle: (
        <>
          יש לבדוק את הגלישה כשהמכשיר
          <br />
          לא מחובר ל-Wifi
        </>
      ),
      action: (
        <SelectList
          options={[
            {key: 'כן, תודה', value: true},
            {key: 'עדיין לא עובד לי', value: false},
          ]}
          onClick={(e) => setSelectedListResult(e)}
        />
      ),
      finishButton: <BtnSubmit text='המשך' onclick={() => submitListResult()} />,
    },
    [TroubleshootingStepEnum.IS_SUBSCRIBER_IN_JORDAN_OR_EGYPT]: {
      icon: null,
      title: 'האם אתה נמצא בירדן או מצרים?',
      subtitle: null,
      action: (
        <SelectList
          options={[
            {key: 'כן', value: true},
            {key: 'לא', value: false},
          ]}
          onClick={(e) => EpiContext.getStore().dispatch(setClientRequestData({isSubscriberInJordanOrEgypt: e}))}
        />
      ),
      finishButton: (
        <BtnSubmit
          text='המשך'
          onclick={async () => {
            EpiContext.getStore().dispatch(setProcessCheckpoint('AfterEgyptJordanSelection'));
            await EpiContext.getStore().dispatch(startTroubleshootingWizard());
          }}
        />
      ),
    },
    [TroubleshootingStepEnum.RESOLVED_ROAMING_SWITCH_BLOCK]: {
      icon: AlertIcon,
      title: 'מעולה, שמחנו לעזור!',
      subtitle: null,
      action: null,
      finishButton: (
        <BtnWhiteBlackBorderBigSize text={epiContent.finishButtonText} onclick={() => navigateToUrl(epiContent.finishButtonLink)} />
      ),
    },

    default: {
      icon: AlertIcon,
      title: null,
      subtitle: null,
      action: null,
      finishButton: (
        <BtnWhiteBlackBorderBigSize
          text={epiContent.finishButtonText}
          onclick={() => {
            navigateToUrl(epiContent.finishButtonLink);
          }}
        />
      ),
    },
  };

  return processContentMap[troubleshootingStep] || processContentMap.default;
};
